import styled, { css } from "styled-components";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

export const Audio = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 14px;
  padding: 8px 18px 8px 8px;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  color: ${colors.brandDark};
  background: ${colors.surface};
  border: 2px solid ${(props) => (props.$playing ? colors.brand : colors.line)};
  box-shadow: ${shadow.card};
`;

export const AudioIcon = styled.button`
  display: grid;
  place-items: center;
  width: 46px;
  height: 46px;
  flex-shrink: 0;
  border-radius: 50%;
  color: #FFFFFF;
  background: ${colors.brand};
  cursor: pointer;
  /* кімната уроку: браузер не дав увімкнути звук сам — підсвічуємо кнопку, учень натискає один раз */
  ${(p) => p.$blocked && `box-shadow: 0 0 0 4px ${colors.amber}; animation: speaksyPulse 1s ease-in-out infinite;`}
  @keyframes speaksyPulse { 50% { box-shadow: 0 0 0 8px ${colors.amberSoft}; } }
`;

export const AudioInfo = styled.span`
  display: flex;
  flex-direction: column;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.2;
`;

export const AudioTime = styled.span`
  font-size: 14px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${colors.muted};
`;

export const AudioBar = styled.span`
  position: relative;
  width: 170px;
  height: 10px;
  border-radius: ${radius.pill};
  background: ${colors.brandSoft};
  cursor: pointer;
  touch-action: none;
`;

export const AudioFill = styled.span`
  position: absolute;
  inset: 0 auto 0 0;
  border-radius: inherit;
  background: ${colors.brand};
`;

export const AudioKnob = styled.span`
  position: absolute;
  top: 50%;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: ${colors.surface};
  border: 3px solid ${colors.brand};
  transform: translate(-50%, -50%);
`;

export const Timer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px;
  border-radius: ${radius.pill};
  background: ${(props) => (props.$done ? colors.dangerSoft : props.$running ? colors.amberSoft : colors.surface)};
  border: 2px solid ${(props) => (props.$done ? colors.danger : props.$running ? colors.amber : colors.line)};
`;

const timerButton = css`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-weight: 800;
  color: ${colors.ink};
  background: none;
  cursor: pointer;
`;

export const TimerButton = styled.button`
  ${timerButton};
  padding: 6px 12px;
  font-size: 26px;
  font-variant-numeric: tabular-nums;
`;

export const TimerReset = styled.button`
  ${timerButton};
  padding: 8px;
  color: ${colors.muted};
`;

// Розмічена нотатка вчителю (NoteText)
export const NoteText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-weight: 500;
  line-height: 1.45;
  h3 {
    margin: 0 0 4px;
    font-size: 18px;
    font-weight: 800;
    color: ${colors.brandDark};
  }
  h4 {
    margin: 12px 0 2px;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${colors.brandDeep};
  }
  p {
    margin: 2px 0;
  }
  b {
    font-weight: 800;
  }
`;

export const NoteItem = styled.div`
  position: relative;
  padding-left: 18px;
  &::before {
    content: "";
    position: absolute;
    left: 4px;
    top: 0.6em;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${colors.amberDeep};
  }
`;
